import { render, staticRenderFns } from "./download-horiz.vue?vue&type=template&id=06305f8e&scoped=true&"
import script from "./download-horiz.vue?vue&type=script&lang=js&"
export * from "./download-horiz.vue?vue&type=script&lang=js&"
import style0 from "./download-horiz.vue?vue&type=style&index=0&id=06305f8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06305f8e",
  null
  
)

export default component.exports